import isEmpty from 'lodash/isEmpty'
import {useEffect, useState} from 'react'
import ModelExample from '../dataModels/ModelExample'

export const useModelExamples = (examplesJSON: string) => {
  const [examples, setExamples] = useState<ModelExample[]>([])

  useEffect(() => {
    try {
      if (!isEmpty(examplesJSON)) {
        let parsedExamples = JSON.parse(examplesJSON)
        let finalExamples = parsedExamples.map((example: any) =>
          Object.assign(new ModelExample(), example)
        )
        setExamples(finalExamples)
      }
    } catch (e) {
      setExamples([])
    }
  }, [examplesJSON])

  return examples
}
